import React from 'react';

export const WorkTitle: React.FC<React.PropsWithChildren> = ({ children }) => (
  <div className="wp-workCard_item wp-workCard--title">{children}</div>
);
